/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mail_Admin_Request_Id_InvalidInputs */

const en_mail_admin_request_id_invalid = /** @type {(inputs: Mail_Admin_Request_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a request ID of at most 100 characters.`)
};

const de_mail_admin_request_id_invalid = /** @type {(inputs: Mail_Admin_Request_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine Anfrage-ID mit höchstens 100 Zeichen an.`)
};

/**
* | output |
* | --- |
* | "Please provide a request ID of at most 100 characters." |
*
* @param {Mail_Admin_Request_Id_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mail_admin_request_id_invalid = /** @type {((inputs?: Mail_Admin_Request_Id_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mail_Admin_Request_Id_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_mail_admin_request_id_invalid(inputs)
	return en_mail_admin_request_id_invalid(inputs)
});